// Brand API helper functions

export async function createBrandApi({ apiUrl, formData, brandType }) {
  const token = localStorage.getItem('brandvox_token');
  const workspaceId = localStorage.getItem('current_workspace_id');

  const data = new FormData();
  data.append('workspace_id', workspaceId);
  data.append('company_name', formData.company_name);
  data.append('brand_type', brandType);
  data.append('workspace_language', formData.workspace_language);

  // Append other basic fields
  if (formData.main_color) data.append('main_color', formData.main_color);
  if (formData.secondary_color) data.append('secondary_color', formData.secondary_color);
  if (formData.accent_color) data.append('accent_color', formData.accent_color);
  if (formData.tagline) data.append('tagline', formData.tagline);
  if (formData.brand_story) data.append('brand_story', formData.brand_story);

  // Multi-selects (handle list)
  ['industry', 'products_services', 'platforms'].forEach(field => {
    if (formData[field] && Array.isArray(formData[field])) {
      formData[field].forEach(item => data.append(field, item));
    }
  });

  // Single selects
  if (formData.organization_type) data.append('organization_type', formData.organization_type);
  if (formData.creator_type) data.append('creator_type', formData.creator_type);
  if (formData.primary_niche) data.append('primary_niche', formData.primary_niche);

  if (formData.logo) data.append('logo', formData.logo);

  const response = await fetch(`${apiUrl}/api/v1/brand/create-brand`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: data
  });

  if (!response.ok) {
    const res = await response.json();
    throw new Error(res.detail || 'Failed to create brand');
  }

  return response.json().catch(() => ({}));
}

export async function updateBrandApi({ apiUrl, formData }) {
  const token = localStorage.getItem('brandvox_token');
  const workspaceId = localStorage.getItem('current_workspace_id');

  const data = new FormData();
  data.append('workspace_id', workspaceId);

  Object.keys(formData).forEach(key => {
    if (key === 'logo') return; // Don't re-upload logo here
    const value = formData[key];
    if (Array.isArray(value)) {
      value.forEach(item => data.append(key, item));
    } else if (value !== null && value !== undefined && value !== '') {
      data.append(key, value);
    }
  });

  const response = await fetch(`${apiUrl}/api/v1/brand/update-brand`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: data
  });

  if (!response.ok) throw new Error('Failed to update brand');

  return response.json().catch(() => ({}));
}

export async function checkTrainingStatus(apiUrl) {
  const token = localStorage.getItem('brandvox_token');
  const workspaceId = localStorage.getItem('current_workspace_id');

  const response = await fetch(
    `${apiUrl}/api/v1/workspace/get-workspace?workspace_id=${workspaceId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  if (!response.ok) return { isTraining: false };

  const workspaceData = await response.json();
  return {
    isTraining: workspaceData.state && workspaceData.state !== 'OK',
    state: workspaceData.state
  };
}
